import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const DEFAULT_STEP_STATE = { currentStep: 0, responses: {} };

export type QuizAnswer = Record<string, any>;

export interface QuizState {
  quizzes: {
    [quizId: string]: {
      currentStep: number;
      responses: {
        [stepName: string]: {
          answer: QuizAnswer;
        };
      };
    };
  };
}

export const initialQuizState: QuizState = {
  quizzes: {},
};

const quizSlice = createSlice({
  name: 'quizzes',
  initialState: initialQuizState,
  reducers: {
    storeQuiz: (
      state,
      action: PayloadAction<{
        quizId: string;
        stepName: string;
        answer: QuizAnswer;
      }>,
    ) => {
      const { quizId, stepName, answer } = action.payload;

      if (!state.quizzes[quizId]) {
        state.quizzes[quizId] = { ...DEFAULT_STEP_STATE };
      }

      state.quizzes[quizId].responses[stepName] = { answer };
    },

    storeCurrentStep: (
      state,
      action: PayloadAction<{ quizId: string; currentStep: number }>,
    ) => {
      const { quizId, currentStep } = action.payload;

      if (!state.quizzes[quizId]) {
        state.quizzes[quizId] = { ...DEFAULT_STEP_STATE };
      }

      state.quizzes[quizId].currentStep = currentStep;
    },

    resetQuiz: (state, action: PayloadAction<string>) => {
      const quizId = action.payload;

      state.quizzes[quizId].currentStep = 0;
      state.quizzes[quizId].responses = {};
    },
  },
});

export const getQuiz = ({
  state,
  quizId,
}: {
  state: QuizState;
  quizId: string;
}): { currentStep: number; responses: { [stepName: string]: QuizAnswer } } =>
  state.quizzes[quizId] || { ...DEFAULT_STEP_STATE };

export const { storeQuiz, storeCurrentStep, resetQuiz } = quizSlice.actions;

export default quizSlice.reducer;
